import { BLOCKS } from '@contentful/rich-text-types';
import { twMerge } from 'tailwind-merge';

import { CHANNEL, THEME_CLASSNAMES } from '@boss/constants/corporate-jobs';
import { RichText } from '@boss/rich-text';
import { NumberCardFields, NumberCardProps, ThemeColor } from '@boss/types/corporate-jobs';

const getNumberCardProps = (
  entry: NumberCardFields,
  locale: string,
  themeColor?: ThemeColor,
  hasBackground?: boolean | undefined,
): NumberCardProps => {
  const themeBackGroundClassName = hasBackground
    ? 'bg-white'
    : themeColor
    ? THEME_CLASSNAMES.background[themeColor]
    : '';
  const defaultBackgroundTextColor = CHANNEL === 'jobs-b2c' ? 'Blue' : 'Green';
  const textClassName = hasBackground ? THEME_CLASSNAMES.text[themeColor ?? defaultBackgroundTextColor] : '';

  return {
    number: (
      <RichText
        className="number m-0"
        content={entry.number}
        mapperOptions={{ locale }}
        renderNode={{
          [BLOCKS.PARAGRAPH]: (_, children) => <>{children}</>,
        }}
      />
    ),
    unit: entry.unit ? (
      <RichText
        className="h1 m-0"
        content={entry.unit}
        mapperOptions={{ locale }}
        renderNode={{
          [BLOCKS.PARAGRAPH]: (_, children) => <>{children}</>,
        }}
      />
    ) : null,
    description: <RichText className="[&>*]:large [&>*]:m-0" content={entry.textAddition} mapperOptions={{ locale }} />,
    className: twMerge(CHANNEL === 'jobs-b2c' ? 'rounded-r-brand rounded-b-brand' : '', themeBackGroundClassName),
    textClassName,
  };
};

export default getNumberCardProps;
